var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.035 20.773-35.918-10.05a1.502 1.502 0 0 0-.809 0l-35.917 10.05a1.499 1.499 0 0 0-1.096 1.444V38.14a1.5 1.5 0 0 0 1.5 1.5h5.474v34.488h-5.474a1.5 1.5 0 0 0-1.5 1.5v9.609a1.5 1.5 0 0 0 1.5 1.5h71.836a1.5 1.5 0 0 0 1.5-1.5v-9.609a1.5 1.5 0 0 0-1.5-1.5h-5.474V39.641h5.474a1.5 1.5 0 0 0 1.5-1.5V22.218c0-.673-.448-1.264-1.096-1.444Zm-70.74 2.582 34.418-9.63 34.418 9.631v6.972H16.295v-6.972Zm6.974 16.285h3.339v34.488h-3.339V39.641Zm14.183 0v34.488h-7.843V39.641h7.843Zm17.184 0v34.488h-7.844V39.641h7.844Zm17.183 0v34.488h-7.844V39.641h7.844ZM60.975 74.128h-3.339V39.641h3.339v34.488Zm-17.183 0h-3.34V39.641h3.34v34.488Zm41.34 9.609H16.295v-6.609h68.836v6.609Zm-6.974-9.609h-3.34V39.641h3.34v34.488Zm6.974-37.488H16.295v-3.313h68.836v3.313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.3e4978ad95248c60ff0f2ab8caf641d0.svg";
export { ForwardRef as ReactComponent };